interface MockMapProps {
  hasLocation: boolean;
}

export function MockMap({ hasLocation }: MockMapProps) {
  return (
    <div
      className="relative mb-8 h-32 w-full overflow-hidden rounded-2xl border border-slate-300 bg-slate-200 flex items-center justify-center"
      aria-label={hasLocation ? 'Localização obtida' : 'Aguardando localização'}
      role="img"
    >
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(#94a3b8 1px, transparent 1px)',
          backgroundSize: '16px 16px',
        }}
        aria-hidden="true"
      />
      {hasLocation ? (
        <>
          <div className="relative z-10 h-4 w-4 rounded-full border-2 border-white bg-blue-500 shadow-sm animate-pulse" />
        </>
      ) : (
        <span className="relative z-10 text-xs font-medium text-slate-400">
          Aguardando GPS…
        </span>
      )}
    </div>
  );
}
